import PropTypes from 'prop-types'
import React from 'react'

import { LANDING_PROMO_HEADER, LANDING_PROMO_MESSAGE } from './translations'
import styles from './LandingPromo.scss'
import { Button, Tooltip } from 'react-wot-bootstrap'
import { LANDING_GOTO_SELECTION_CLAN, LANDING_GOTO_SELECTION_CLAN_TOOLTIP } from '../../translations'

const LandingPromo = ({ onGoToRecommendedClansButtonClick }) => {
    return (
        <div className={styles.base}>
            <div className={styles.header}>{LANDING_PROMO_HEADER}</div>
            <div className={styles.message}>
                <div className={styles.text}>{LANDING_PROMO_MESSAGE}</div>
            </div>
            <div className={styles.buttonWrapper}>
                <div className={styles.glowing} />
                <Button
                    type="primary"
                    tooltipId="goto_selection_clan_tooltip"
                    onClick={onGoToRecommendedClansButtonClick}
                >
                    <span>{LANDING_GOTO_SELECTION_CLAN}</span>
                </Button>
                <Tooltip id="goto_selection_clan_tooltip">
                    {LANDING_GOTO_SELECTION_CLAN_TOOLTIP}
                </Tooltip>
            </div>
        </div>
    )
}

LandingPromo.propTypes = {
    onGoToRecommendedClansButtonClick: PropTypes.func.isRequired,
}

export default LandingPromo



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingPromo/LandingPromo.jsx